"use strict";

exports.__esModule = true;
exports.vehicleUpdateModelList = exports.vehicleDelete = exports.updateCurrentOrder = exports.showHideVehicleList = void 0;
var _actionTypes = require("./action-types");
var vehicleUpdateModelList = function vehicleUpdateModelList(vehicleCode, modelCode, index) {
  return {
    type: _actionTypes.VEHICLE_UPDATE_MODEL_LIST,
    vehicleCode: vehicleCode,
    modelCode: modelCode,
    index: index
  };
};
exports.vehicleUpdateModelList = vehicleUpdateModelList;
var vehicleDelete = function vehicleDelete(index) {
  return {
    type: _actionTypes.VEHICLE_DELETE,
    index: index
  };
};
exports.vehicleDelete = vehicleDelete;
var updateCurrentOrder = function updateCurrentOrder(index) {
  return {
    type: _actionTypes.VEHICLE_UPDATE_CURRENT_INDEX,
    index: index
  };
};
exports.updateCurrentOrder = updateCurrentOrder;
var showHideVehicleList = function showHideVehicleList(flag) {
  return {
    type: _actionTypes.VEHICLE_LIST_SHOW_HIDE,
    flag: flag
  };
};
exports.showHideVehicleList = showHideVehicleList;